import React from 'react';

import { SearchableMultiSelectDropdown } from '@/components/SearchableMultiSelectDropdown';
import { AgentStatus, Filter } from '@/hooks/useAgents';
import { omit } from '@/utils/lodash.util';

interface AgentsTableFiltersProps {
  filter: Filter;
  setFilter: (updater: (prev: Filter) => Filter) => void;
}

/**
 * Filter controls for the agents table
 *
 * Renders inline filter dropdowns for use inside TableControlsContainer.
 * Layout and spacing is handled by the parent container.
 */
export const AgentsTableFilters: React.FC<AgentsTableFiltersProps> = ({
  filter,
  setFilter,
}) => {
  return (
    <SearchableMultiSelectDropdown
      isLoading={false}
      label={'Status'}
      options={[
        {
          label: 'Online',
          value: 'online',
          id: 'online',
        },
        {
          label: 'Offline',
          value: 'offline',
          id: 'offline',
        },
      ]}
      selectedValues={filter?.status || []}
      onApply={selected => {
        setFilter(prev => {
          return selected.length > 0
            ? {
                ...prev,
                status: selected.map(option => option.value as AgentStatus),
              }
            : omit(prev, 'status');
        });
      }}
      onClear={() => {
        setFilter(prev => omit(prev, 'status'));
      }}
    />
  );
};
